import { PostHogProvider } from 'posthog-js/react'
import { PropsWithChildren } from 'react'

export const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  if (import.meta.env.VITE_ENV !== 'production') {
    return children
  }

  return (
    <PostHogProvider
      apiKey={import.meta.env.VITE_POSTHOG_KEY}
      options={{ api_host: import.meta.env.VITE_POSTHOG_HOST, capture_pageview: 'history_change' }}
    >
      {children}
    </PostHogProvider>
  )
}
